// RetroFam Article Template JavaScript - All Unique Classes

document.addEventListener('DOMContentLoaded', function() {
  console.log('RetroFam Article Template JavaScript loaded');
  
  // Remove loading state
  const articleDetails = document.querySelector('.retrofam-article-details');
  if (articleDetails) {
    articleDetails.classList.remove('loading');
  }
  
  // Initialize all functionality
  initSocialSharing();
  initTableOfContents();
  initRelatedBlogsCarousel();
  initProductsCarousel();
  initBuyNowFunction();
});
 
// Add loading state immediately when script loads
(function() {
  const articleDetails = document.querySelector('.retrofam-article-details');
  if (articleDetails) {
    articleDetails.classList.add('loading');
  }
})();

// Social Media Sharing
function initSocialSharing() {
  const socialIcons = document.querySelectorAll('.retrofam-social-icon');
  
  socialIcons.forEach(icon => {
    icon.addEventListener('click', function() {
      const platform = this.getAttribute('data-platform');
      const blogUrl = window.location.href;
      const blogTitle = document.querySelector('.retrofam-banner-title')?.textContent || 'RetroFam Blog Post';
      
      const encodedUrl = encodeURIComponent(blogUrl);
      const encodedTitle = encodeURIComponent(blogTitle);
      
      const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`,
        email: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
        link: blogUrl
      };
      
      if (platform === 'link') {
        navigator.clipboard.writeText(blogUrl).then(() => {
          showToast('Link copied to clipboard!');
        }).catch(() => {
          showToast('Failed to copy link');
        });
      } else {
        window.open(shareLinks[platform], '_blank');
      }
    });
  });
}

// Table of Contents Functionality
function initTableOfContents() {
  const tocContainer = document.querySelector('.retrofam-toc-list');
  if (!tocContainer) return;
  
  // Generate table of contents
  generateTableOfContents();
  
  // Set up scroll listener for active TOC
  window.addEventListener('scroll', updateActiveTOC);
  updateActiveTOC();
}

function generateTableOfContents() {
  const tocContainer = document.querySelector('.retrofam-toc-list');
  if (!tocContainer) return;
  
  // Clear existing TOC items
  tocContainer.innerHTML = '';
  
  // Get all h2 headings and ensure they have IDs
  const h2Headings = document.querySelectorAll('.retrofam-article-body h2');
  
  h2Headings.forEach((heading, index) => {
    // Generate ID if it doesn't exist
    if (!heading.id) {
      const headingText = heading.textContent;
      const headingId = headingText
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '_')
        .trim();
      heading.id = headingId;
    }
    
    const headingId = heading.getAttribute('id');
    const headingText = heading.textContent;
    
    // Create TOC item
    const tocItem = document.createElement('li');
    tocItem.className = 'retrofam-toc-item';
    tocItem.setAttribute('data-target', headingId);
    
    const tocLink = document.createElement('a');
    tocLink.href = `#${headingId}`;
    tocLink.className = 'retrofam-toc-link';
    tocLink.textContent = headingText;
    
    tocItem.appendChild(tocLink);
    tocContainer.appendChild(tocItem);
  });
  
  // Attach click event listeners
  attachTOCEventListeners();
}

function attachTOCEventListeners() {
  const tocItems = document.querySelectorAll('.retrofam-toc-item');
  
  tocItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

function updateActiveTOC() {
  const scrollPosition = window.scrollY + 100;
  const tocItems = document.querySelectorAll('.retrofam-toc-item');
  const headings = document.querySelectorAll('.retrofam-article-body h2[id]');
  
  headings.forEach((heading) => {
    const headingTop = heading.offsetTop;
    const headingBottom = headingTop + heading.offsetHeight;
    
    if (scrollPosition >= headingTop && scrollPosition < headingBottom) {
      tocItems.forEach(item => item.classList.remove('active'));
      
      const targetId = heading.getAttribute('id');
      const activeTOCItem = document.querySelector(`[data-target="${targetId}"]`);
      if (activeTOCItem) {
        activeTOCItem.classList.add('active');
      }
    }
  });
}

// Related Blogs Carousel
function initRelatedBlogsCarousel() {
  const carouselContainer = document.getElementById('retrofamCarouselContainer');
  const prevBtn = document.getElementById('retrofamPrevBtn');
  const nextBtn = document.getElementById('retrofamNextBtn');
  
  if (!carouselContainer || !prevBtn || !nextBtn) return;
  
  let currentIndex = 0;
  let maxIndex = 0;
  let isInitialized = false;
  
  function calculateMaxIndex() {
    const containerWidth = carouselContainer.offsetWidth;
    const totalCards = carouselContainer.children.length;
    
    // Get actual card width including gap
    const firstCard = carouselContainer.children[0];
    if (firstCard) {
      const cardWidth = firstCard.offsetWidth;
      const gap = 20; // 1.25rem = 20px
      const cardWidthWithGap = cardWidth + gap;
      const visibleCards = Math.floor(containerWidth / cardWidthWithGap);
      maxIndex = Math.max(0, totalCards - visibleCards);
    } else {
      maxIndex = Math.max(0, totalCards - 1);
    }
  }
  
  function updateCarousel() {
    if (!isInitialized) return;
    
    const firstCard = carouselContainer.children[0];
    if (!firstCard) return;
    
    const cardWidth = firstCard.offsetWidth;
    const gap = 20; // 1.25rem = 20px
    const cardWidthWithGap = cardWidth + gap;
    const translateX = -currentIndex * cardWidthWithGap;
    
    carouselContainer.style.transform = `translateX(${translateX}px)`;
    
    // Update button states
    prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
    prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
    nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
    nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto';
  }
  
  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });
  
  nextBtn.addEventListener('click', () => {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });
  
  // Touch/swipe support
  let startX = 0;
  let endX = 0;
  let isDragging = false;
  
  carouselContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
    e.preventDefault();
  }, { passive: false });
  
  carouselContainer.addEventListener('touchmove', (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  }, { passive: false });
  
  carouselContainer.addEventListener('touchend', (e) => {
    if (isDragging) {
      endX = e.changedTouches[0].clientX;
      handleSwipe();
      isDragging = false;
      e.preventDefault();
    }
  }, { passive: false });
  
  function handleSwipe() {
    const swipeThreshold = 30;
    const diff = startX - endX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        nextBtn.click();
      } else {
        prevBtn.click();
      }
    }
  }
  
  // Initialize carousel
  function initializeCarousel() {
    calculateMaxIndex();
    isInitialized = true;
    updateCarousel();
  }
  
  // Initialize after a delay to ensure DOM is ready
  setTimeout(initializeCarousel, 200);
  
  // Update on window resize
  window.addEventListener('resize', () => {
    calculateMaxIndex();
    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }
    updateCarousel();
  });
}

// Products Carousel
function initProductsCarousel() {
  const productsContainer = document.getElementById('retrofamProductsContainer');
  const productsPrevBtn = document.getElementById('retrofamProductsPrevBtn');
  const productsNextBtn = document.getElementById('retrofamProductsNextBtn');
  
  if (!productsContainer || !productsPrevBtn || !productsNextBtn) return;
  
  let productsCurrentIndex = 0;
  let productsMaxIndex = 0;
  let isInitialized = false;
  
  function calculateProductsMaxIndex() {
    const track = productsContainer; // moving element
    const wrapper = productsContainer.parentElement; // .retrofam-products-carousel
    const wrapperStyle = window.getComputedStyle(wrapper);
    const padLeft = parseFloat(wrapperStyle.paddingLeft) || 0;
    const padRight = parseFloat(wrapperStyle.paddingRight) || 0;
    const containerWidth = wrapper.clientWidth - padLeft - padRight;
    const totalProducts = track.children.length;

    const firstCard = track.children[0];
    if (firstCard) {
      const cardStyle = window.getComputedStyle(firstCard);
      const cardWidth = firstCard.getBoundingClientRect().width; // include borders
      // gap is taken from track's gap (flex gap); fallback 24
      const gap = parseFloat(window.getComputedStyle(track).gap || 0) || 24;
      const cardWidthWithGap = cardWidth + gap;
      const visibleProducts = Math.max(1, Math.floor((containerWidth + gap) / cardWidthWithGap));
      productsMaxIndex = Math.max(0, totalProducts - visibleProducts);
      track.dataset.step = cardWidthWithGap; // cache step
    } else {
      productsMaxIndex = 0;
    }
  }
  
  function updateProductsCarousel() {
    if (!isInitialized) return;
    
    const step = parseFloat(productsContainer.dataset.step || 324); // 300 + 24 fallback
    const translateX = -productsCurrentIndex * step;
    
    productsContainer.style.transform = `translateX(${translateX}px)`;
    
    // Update button states
    productsPrevBtn.style.opacity = productsCurrentIndex === 0 ? '0.5' : '1';
    productsPrevBtn.style.pointerEvents = productsCurrentIndex === 0 ? 'none' : 'auto';
    productsNextBtn.style.opacity = productsCurrentIndex >= productsMaxIndex ? '0.5' : '1';
    productsNextBtn.style.pointerEvents = productsCurrentIndex >= productsMaxIndex ? 'none' : 'auto';
  }
  
  function goToNext() {
    if (productsCurrentIndex < productsMaxIndex) {
      productsCurrentIndex++;
      updateProductsCarousel();
    }
  }
  
  function goToPrev() {
    if (productsCurrentIndex > 0) {
      productsCurrentIndex--;
      updateProductsCarousel();
    }
  }
  
  // Button event listeners
  productsPrevBtn.addEventListener('click', goToPrev);
  productsNextBtn.addEventListener('click', goToNext);
  
  // Touch/swipe support
  let productsStartX = 0;
  let productsEndX = 0;
  let isDragging = false;
  
  productsContainer.addEventListener('touchstart', (e) => {
    productsStartX = e.touches[0].clientX;
    isDragging = true;
    e.preventDefault();
  }, { passive: false });
  
  productsContainer.addEventListener('touchmove', (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  }, { passive: false });
  
  productsContainer.addEventListener('touchend', (e) => {
    if (isDragging) {
      productsEndX = e.changedTouches[0].clientX;
      handleProductsSwipe();
      isDragging = false;
      e.preventDefault();
    }
  }, { passive: false });
  
  function handleProductsSwipe() {
    const swipeThreshold = 30;
    const diff = productsStartX - productsEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
  }
  
  // Initialize carousel
  function initializeProductsCarousel() {
    calculateProductsMaxIndex();
    isInitialized = true;
    updateProductsCarousel();
  }
  
  // Initialize after a delay to ensure DOM is ready
  setTimeout(initializeProductsCarousel, 100);
  
  // Update on window resize
  window.addEventListener('resize', () => {
    calculateProductsMaxIndex();
    if (productsCurrentIndex > productsMaxIndex) {
      productsCurrentIndex = productsMaxIndex;
    }
    updateProductsCarousel();
  });
}

// Buy Now Function
function initBuyNowFunction() {
  // Make retrofamBuyNow globally available
  window.retrofamBuyNow = function() {
    // Get the featured product from meta fields
    const featuredProduct = document.querySelector('.retrofam-featured-product');
    if (featuredProduct) {
      // Check for Amazon link first, then eBay
      const amazonLink = featuredProduct.querySelector('a[href*="amazon"]');
      const ebayLink = featuredProduct.querySelector('a[href*="ebay"]');
      
      if (amazonLink) {
        window.open(amazonLink.href, '_blank');
      } else if (ebayLink) {
        window.open(ebayLink.href, '_blank');
      } else {
        showToast('No purchase link available');
      }
    } else {
      showToast('No featured product found');
    }
  };
}

// Toast Notification
function showToast(message) {
  const toast = document.getElementById('retrofamToast');
  if (!toast) return;
  
  toast.textContent = message;
  toast.classList.add('show');
  
  setTimeout(() => {
    toast.classList.remove('show');
  }, 3000);
}

// Shop Now Button
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('retrofam-shop-now-btn')) {
    // Redirect to shop page or handle shop now action
    window.location.href = '/collections/all';
  }
});

// Blog Card Links
document.addEventListener('click', function(e) {
  const blogCard = e.target.closest('.retrofam-blog-card');
  if (blogCard) {
    const titleLink = blogCard.querySelector('.retrofam-blog-card-title');
    if (titleLink && titleLink.href) {
      window.location.href = titleLink.href;
    }
  }
});

// Product Item Links
document.addEventListener('click', function(e) {
  const productItem = e.target.closest('.retrofam-product-item');
  if (productItem) {
    const titleLink = productItem.querySelector('.retrofam-product-item-title');
    if (titleLink && titleLink.href) {
      window.location.href = titleLink.href;
    }
  }
});

console.log('RetroFam Article Template JavaScript initialized successfully');